module.exports = __webpack_public_path__ + "img/9788991204980.b5cc30b1.jpg";